module.exports = __webpack_public_path__ + "static/media/principal.d3b440ef.png";